import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({});
const ReactsCard = (props: any) => {
    useStyles();
       return <Card {...props}>
                {props.title && <CardHeader title={props.title} />}
                <CardContent>
            {props.children}
        </CardContent>
    </Card>
};


export default ReactsCard;
